import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/storeConfiguration';
import { Provider } from 'react-redux';
import './index.css';
import MICROSOFT_CLARITY_SCRIPT from './constants/analytics';
import { ABTestingProvider } from './components/ABTestingProvider/ABTestingProvider';
import {
  ThemeProvider,
  SettingsProvider,
  LocalizationProvider,
} from "hello-design-system";
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

if (process.env.REACT_APP_MICROSOFT_CLARITY_IS_ENABLED === 'true') {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.innerHTML = MICROSOFT_CLARITY_SCRIPT;
  document.head.appendChild(script);
}

const muiTheme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MuiThemeProvider theme={muiTheme}>
        <SettingsProvider
          defaultSettings={{
            themeMode: "light",
            themeDirection: "ltr",
            themeContrast: "default",
            themeLayout: "vertical",
            themeColorPresets: "default",
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <LocalizationProvider>
              <ABTestingProvider>
                <App />
              </ABTestingProvider>
            </LocalizationProvider>
          </ThemeProvider>
        </SettingsProvider>
      </MuiThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
